'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';

/**
 * Expand the hit area to at least 44×44px on touch devices.
 * The element rendering this must be positioned (`relative`), otherwise the overlay
 * sizes itself against a far ancestor and swallows every tap on the page.
 */
export function TouchTarget(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="absolute top-1/2 left-1/2 size-[max(100%,2.75rem)] -translate-x-1/2 -translate-y-1/2 [@media(pointer:fine)]:hidden" aria-hidden="true" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <>{t1}{children}</>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}